export default "__VITE_ASSET__D1xa7Myl__"